(function (global, $, jcf, Si) {
    "use strict";

    Si.when('Ajax/LineUps', 'Templates', 'Helpers', 'PlayerStatModal').then(lineUpsPage);

    function lineUpsPage(LineUps, Templates, Helpers, PlayerStatModal) {
        var controls = {},
            params = {current_page: 1, max_pages: 0},

            changeHandlers = {
                "country": countryChangeHandler,
                "tournament": tournamentChangeHandler,
                "season": seasonChangeHandler,
                "team": teamChangeHandler,
                "match": matchChangeHandler

            },
            $viewsHolder = $('[data-view-line-ups]'),
            $loader = $('[data-loader]');

        initControls();

        function initControls() {
            jcf.setOptions(
                'Select', {
                    wrapNative: false,
                    wrapNativeOnMobile: true
                }
            );
            jcf.replaceAll();

            controls['all'] = $('[data-control]');

            controls['all'].each(
                function () {
                    var $ctrl = $(this),
                        name = $ctrl.data('control');
                    controls[$ctrl.data('control')] = $ctrl;
                    if ($ctrl.is('select')) {
                        $ctrl.data('lastValue', $ctrl.val());
                        $ctrl.on('change', getSelectChangeHandler(name));
                    } else {
                        $ctrl.on('change', changeHandlers[name]);
                    }
                }
            );

            $(document).on('click', '.page-item', function(e){
                e.preventDefault();
                params.current_page = $(this).data('page');
                loadPage();
            });

            $('.next').click(function(e){
                e.preventDefault();
                if(params.max_pages > params.current_page){

                    params.current_page++;
                    loadPage();
                }
            });
            $('.prev').click(function(e){
                e.preventDefault();
                if(params.current_page > 1){
                    params.current_page--;
                    loadPage();
                }
            });

            loadData('all');
            getLineUps();
        }

        function loadPage(){
            var pages = [];
            for(var i = params.current_page; i < params.current_page+5 && i <= params.max_pages; i++){
                if(i==params.current_page){
                    pages.push({num: i, class: 'active'});
                }else{
                    pages.push({num: i});
                }
            }
            $('#paginator').html(Templates.make('controls/prev_line_ups_paginator.mustache', {pages: pages}));
            getLineUps();
        }

        function getSelectChangeHandler(name) {

            return function (event) {
                // check if value really changed
                var $ctrl = $(this),
                    newVal = $ctrl.val(),
                    lastVal = $ctrl.data('lastValue');
                if (newVal != lastVal) {
                    $ctrl.data('lastValue', newVal);
                    return changeHandlers[name].call(this, event);
                }
            };
        }


        function countryChangeHandler(event) {
            loadData('country');
        }

        function tournamentChangeHandler(event) {
            loadData('tournament');
        }

        function seasonChangeHandler(event) {
            loadData('season');
        }

        function teamChangeHandler(event) {
            loadData('team');
        }

        function matchChangeHandler(event) {
            loadData('match');
            getLineUps();
        }

        function getLineUps() {
            $loader.addClass('visible');

            return LineUps.get(params).then(
                function (response) {
                    renderView('line-ups', response);
                    if(typeof response.num_of_pages != 'undefined'){
                        params.max_pages = response.num_of_pages;
                        $('#paginator_total').html('of '+params.max_pages);
                    }
                    PlayerStatModal.initPlayerStatModal(
                        '[data-stat-modal]',
                        '.player-modal-link',
                        '[data-season-link]',
                        '[data-team-link]',
                        '[data-table]'
                    );
                    $('.player_cell').each(function () {

                        $(this).mouseover(function () {
                            var id = $(this).data('id');
                            $('.player_cell_' + id).addClass('active');
                        });
                        $(this).mouseout(function () {
                            var id = $(this).data('id');
                            $('.player_cell_' + id).removeClass('active');
                        });
                    });
                    $loader.removeClass('visible');
                }, function (status, error) {

                }
            );
        }

        function loadData(triggerName) {
            params = {};
            params = fillLoadParams(
                triggerName,
                params
            );

            if (triggerName != 'all' && triggerName != 'match') {
                var form_data = {
                    changeInput: true,
                    input: triggerName,
                    country: params.country,
                    team: params.team,
                    season: params.season,
                    tournament: params.tournament,
                    match: params.match
                }


                return LineUps.get(form_data).then(
                    function (response) {
                        updateControlsFromResponse(response);
                        params = {};
                        params = fillLoadParams(
                            triggerName,
                            params
                        );
                        getLineUps();
                        $loader.removeClass('visible');
                    }, function (status, error) {

                        console.log(status, error);
                        alert('Error appear while data loading...');
                        $loader.removeClass('visible');
                    }
                );
            }

        }

        function fillLoadParams(triggerName, params) {


            params['country'] = controls.country.val();
            params['tournament'] = controls.tournament.val();
            params['team'] = controls.team.val();
            params['season'] = controls.season.val();
            params['match'] = controls.match.val();
            params['current_page'] = $('.page-item.active').data('page');

            return params;
        }

        function updateControlsFromResponse(response) {

            if (response['tournaments']) {
                updateSelectOptions(controls.tournament, response['tournaments'], 'tournaments');
            }

            if (response['teams']) {
                updateSelectOptions(controls.team, response['teams'], 'teams');
            }

            if (response['seasons']) {
                updateSelectOptions(controls.season, response['seasons'], 'seasons');
            }

            if (response['matches']) {
                updateSelectOptions(controls.match, response['matches'], 'matches');
            }
        }

        function updateSelectOptions($select, items, tplKey, preselectFirst) {

            var len = items.length;
            if (len && preselectFirst) {
                items[0]['pre_selected'] = true;
            }
            items.isEmpty = function () {
                return !len;
            };
            var tplData = {};
            tplData[tplKey] = items;
            $select.empty();
            if(tplKey == 'seasons'){
                $select.append(Templates.make('controls/' + tplKey + '-options-no-all.mustache', tplData));
            }else{
                $select.append(Templates.make('controls/' + tplKey + '-options.mustache', tplData));
            }

            getJcf($select).refresh();
        }

        function getJcf(element) {

            return jcf.getInstance(element);
        }

        function renderView(view, data) {

            var content = Templates.make('match/' + view + '.mustache', data);
            $viewsHolder.empty();
            $viewsHolder.append(content);
			teamSameHeight();
            $loader.removeClass('visible');
        }

		$(window).on('resize', function() {
			teamSameHeight();
		});
		function teamSameHeight() {
			var height = [];

			$('.team-sameheight').each(function() {
				if ($(window).width() >= 1200) {
					$(this).find('.team-body ul').each(function() {
						$(this).find('li').each(function(i) {
							if ( !height[i] || height[i]<$(this).outerHeight() ) {
								height[i] = $(this).outerHeight();
							}
						});
					});

					$(this).find('.team-body ul').each(function() {
						$(this).find('li').each(function(i) {
							$(this).css('height', height[i]);
						});
					});

				} else{
					$('.team-sameheight .team-body ul li').css('height', '');

				}
			});
		}
    }
})(window, jQuery, jcf, Si);
